import { createPinia } from 'pinia'
import type { App } from 'vue'

export default {
    install(app: App): void {
        const pinia = createPinia()
        app.use(pinia)
    }
}
